import emailjs from '@emailjs/browser';

// EmailJS Configuration
const EMAILJS_SERVICE_ID = 'service_7vcxt8m'; // Updated to match actual service ID
const EMAILJS_PUBLIC_KEY = '7TkUCJChetSbqUxvL';

// Initialize EmailJS
emailjs.init(EMAILJS_PUBLIC_KEY);

// Universal template ID - using your single template for all email types
const UNIVERSAL_TEMPLATE_ID = 'template_lgex1uk';

// Frontend URL
const FRONTEND_URL = 'https://cyborgsapient.com/';

// Helper function to sanitize template variables
const sanitizeTemplateParam = (value) => {
  if (value === null || value === undefined) return '';
  // Convert to string, trim, and ensure it's a valid string
  let sanitized = String(value).trim();
  // Replace any null bytes or control characters that might break EmailJS
  sanitized = sanitized.replace(/\0/g, '').replace(/[\x00-\x1F\x7F]/g, '');
  return sanitized;
};

// Email sending functions
export const sendRegistrationConfirmation = async (influencerData) => {
  try {
    const templateParams = {
      to_email: sanitizeTemplateParam(influencerData.email || ''),
      to_name: sanitizeTemplateParam(influencerData.name || 'Influencer'),
      custom_message: sanitizeTemplateParam(`Thank you for registering as an influencer with Cyborgsapient! Your application has been received and is currently under review. Our team will review your application and get back to you within 2-3 business days.`),
      influencer_name: sanitizeTemplateParam(influencerData.name || 'Influencer'),
      influencer_email: sanitizeTemplateParam(influencerData.email || ''),
      instagram_handle: sanitizeTemplateParam(influencerData.instagram || ''),
      influencer_type: sanitizeTemplateParam(influencerData.influencerType || 'Normal'),
      status: sanitizeTemplateParam('Pending Review'),
      influencer_id: sanitizeTemplateParam(''),
      frontend_url: sanitizeTemplateParam(FRONTEND_URL),
      current_year: sanitizeTemplateParam(String(new Date().getFullYear())),
    };

    const result = await emailjs.send(
      EMAILJS_SERVICE_ID,
      UNIVERSAL_TEMPLATE_ID,
      templateParams
    );

    console.log('✅ Registration confirmation email sent:', result.text);
    return { success: true, messageId: result.text };
  } catch (error) {
    console.error('❌ Failed to send registration email:', error);
    return { success: false, error: error.message };
  }
};

export const sendApprovalNotification = async (influencerData) => {
  try {
    const influencerId = influencerData.influencerId || influencerData._id || '';
    const templateParams = {
      to_email: sanitizeTemplateParam(influencerData.email || ''),
      to_name: sanitizeTemplateParam(influencerData.name || 'Influencer'),
      custom_message: sanitizeTemplateParam(`🎉 Congratulations! Your influencer application has been approved and you're now part of the Cyborgsapient influencer community. Your Influencer ID is ${influencerId || 'N/A'}. You can now log in to your account and start connecting with brands!`),
      influencer_name: sanitizeTemplateParam(influencerData.name || 'Influencer'),
      influencer_email: sanitizeTemplateParam(influencerData.email || ''),
      instagram_handle: sanitizeTemplateParam(influencerData.instagram || ''),
      influencer_type: sanitizeTemplateParam(influencerData.influencerType || 'Normal'),
      status: sanitizeTemplateParam('Approved'),
      influencer_id: sanitizeTemplateParam(influencerId),
      frontend_url: sanitizeTemplateParam(FRONTEND_URL),
      current_year: sanitizeTemplateParam(String(new Date().getFullYear())),
    };

    const result = await emailjs.send(
      EMAILJS_SERVICE_ID,
      UNIVERSAL_TEMPLATE_ID,
      templateParams
    );

    console.log('✅ Approval notification email sent:', result.text);
    return { success: true, messageId: result.text };
  } catch (error) {
    console.error('❌ Failed to send approval email:', error);
    return { success: false, error: error.message };
  }
};

export const sendRejectionNotification = async (influencerData) => {
  try {
    const templateParams = {
      to_email: sanitizeTemplateParam(influencerData.email || ''),
      to_name: sanitizeTemplateParam(influencerData.name || 'Influencer'),
      custom_message: sanitizeTemplateParam(`Thank you for your interest in becoming an influencer with Cyborgsapient. After careful review, we're unable to approve your application at this time. We encourage you to continue building your social media presence and reapply in the future when you feel ready.`),
      influencer_name: sanitizeTemplateParam(influencerData.name || 'Influencer'),
      influencer_email: sanitizeTemplateParam(influencerData.email || ''),
      instagram_handle: sanitizeTemplateParam(influencerData.instagram || ''),
      influencer_type: sanitizeTemplateParam(influencerData.influencerType || 'Normal'),
      status: sanitizeTemplateParam('Not Approved'),
      influencer_id: sanitizeTemplateParam(influencerData.influencerId || ''),
      frontend_url: sanitizeTemplateParam(FRONTEND_URL),
      current_year: sanitizeTemplateParam(String(new Date().getFullYear())),
    };

    const result = await emailjs.send(
      EMAILJS_SERVICE_ID,
      UNIVERSAL_TEMPLATE_ID,
      templateParams
    );

    console.log('✅ Rejection notification email sent:', result.text);
    return { success: true, messageId: result.text };
  } catch (error) {
    console.error('❌ Failed to send rejection email:', error);
    return { success: false, error: error.message };
  }
};

export const sendPasswordCreationConfirmation = async (influencerData) => {
  try {
    const templateParams = {
      to_email: sanitizeTemplateParam(influencerData.email || ''),
      to_name: sanitizeTemplateParam(influencerData.name || 'Influencer'),
      custom_message: sanitizeTemplateParam(`🎉 Your account setup is now complete! You can now access all features of your influencer dashboard. Complete your profile, set your pricing, browse collaboration opportunities, and start connecting with brands looking for influencers.`),
      influencer_name: sanitizeTemplateParam(influencerData.name || 'Influencer'),
      influencer_email: sanitizeTemplateParam(influencerData.email || ''),
      instagram_handle: sanitizeTemplateParam(influencerData.instagram || ''),
      influencer_type: sanitizeTemplateParam(influencerData.influencerType || 'Normal'),
      status: sanitizeTemplateParam('Account Setup Complete'),
      influencer_id: sanitizeTemplateParam(influencerData.influencerId || ''),
      frontend_url: sanitizeTemplateParam(FRONTEND_URL),
      current_year: sanitizeTemplateParam(String(new Date().getFullYear())),
    };

    const result = await emailjs.send(
      EMAILJS_SERVICE_ID,
      UNIVERSAL_TEMPLATE_ID,
      templateParams
    );

    console.log('✅ Password creation confirmation email sent:', result.text);
    return { success: true, messageId: result.text };
  } catch (error) {
    console.error('❌ Failed to send password creation email:', error);
    return { success: false, error: error.message };
  }
};

// Test function to verify EmailJS setup
export const testEmailJS = async () => {
  try {
    const templateParams = {
      to_email: sanitizeTemplateParam('vivekkumar787067@gmail.com'),
      to_name: sanitizeTemplateParam('Test User'),
      custom_message: sanitizeTemplateParam('This is a test email from Cyborgsapient EmailJS setup. If you receive this, the email system is working correctly!'),
      influencer_name: sanitizeTemplateParam('Test User'),
      influencer_email: sanitizeTemplateParam('vivekkumar787067@gmail.com'),
      instagram_handle: sanitizeTemplateParam('@testuser'),
      influencer_type: sanitizeTemplateParam('Normal'),
      status: sanitizeTemplateParam('Test'),
      influencer_id: sanitizeTemplateParam(''),
      frontend_url: sanitizeTemplateParam(FRONTEND_URL),
      current_year: sanitizeTemplateParam(String(new Date().getFullYear())),
    };

    const result = await emailjs.send(
      EMAILJS_SERVICE_ID,
      UNIVERSAL_TEMPLATE_ID,
      templateParams
    );

    console.log('✅ EmailJS test successful:', result.text);
    return { success: true, messageId: result.text };
  } catch (error) {
    console.error('❌ EmailJS test failed:', error);
    return { success: false, error: error.message };
  }
};

export default {
  sendRegistrationConfirmation,
  sendApprovalNotification,
  sendRejectionNotification,
  sendPasswordCreationConfirmation,
  testEmailJS
};
